/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useState } from 'react'
import ErrorLabel from 'ui/atoms/ErrorLabel'

import { QuestionTitle } from './Text'

type Option = {
  value: any
  label: string
  disabled?: boolean
}

type Props = {
  hasError?: boolean
  inputId?: string
  disabled?: boolean
  grayOutWhenDisabled?: boolean
  willShowNotAllowedCursor?: boolean
  onChange: (value: string) => void
  value?: any
  label?: string
  placeholder?: string
  options: Option[]
  errorLabel?: string
  name?: string
  isOfficeUse?: boolean
  isRequired?: boolean
  hidePlaceholder?: boolean
  $small?: boolean
  $medium?: boolean
}

function Dropdown({
  hasError,
  inputId,
  disabled,
  grayOutWhenDisabled,
  willShowNotAllowedCursor,
  onChange,
  value,
  label,
  placeholder,
  options,
  errorLabel,
  name,
  isOfficeUse,
  isRequired,
  hidePlaceholder,
  $small,
  $medium,
  ...props
}: Props) {
  const [placeholderLabel, setPlaceholderLabel] = useState('')

  useEffect(() => {
    setPlaceholderLabel(`-- ${placeholder} --`)
  }, [placeholder])

  let classes =
    'form-input focus:!border-primary focus:shadow-[0_0_0_2px_rgba(5,130,255,0.08)] border block transition duration-150 ease-in-out sm:text-sm sm:leading-5'
  if (willShowNotAllowedCursor) {
    classes += ' cursor-not-allowed bg-gray-100'
  }

  if (hasError) {
    classes += ' border-red-500'
  }

  if (!value || value === placeholderLabel) {
    classes += ' text-gray-400'
  }

  if (disabled && grayOutWhenDisabled) {
    classes += ' bg-gray-100'
  }

  if ($small) {
    classes += ' w-24'
  } else if ($medium) {
    classes += ' w-40'
  } else {
    classes += ' w-full'
  }

  const handleChange = disabled
    ? // eslint-disable-next-line @typescript-eslint/no-empty-function
      () => {}
    : (e: React.ChangeEvent<HTMLSelectElement>) => {
        onChange(e.target.value)
      }

  const dropdownValue = value || ''
  return (
    <div>
      {label && (
        <QuestionTitle
          htmlFor={name}
          isOfficeUse={isOfficeUse}
          isRequired={isRequired}
        >
          {label}
        </QuestionTitle>
      )}
      <select
        className={classes}
        disabled={disabled}
        id={inputId}
        onChange={handleChange}
        value={dropdownValue}
        {...props}
      >
        {!hidePlaceholder && (
          // @ts-ignore
          <option defaultValue value="">
            {placeholderLabel}
          </option>
        )}
        {options.map((o) => (
          <option disabled={o.disabled} key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {hasError && <ErrorLabel>{errorLabel}</ErrorLabel>}
    </div>
  )
}

export default Dropdown
